import React, { useEffect, useState } from 'react';
import { Card, Col, Nav, Offcanvas, Row, Tab } from 'react-bootstrap';
import ContactDetailsHeader from './ContactDetailsHeader';
import SimpleBar from 'simplebar-react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Notes from './Notes';
import ContactProfile from './ContactProfile';
import IconButton from 'components/common/IconButton';
import { useParams } from 'react-router-dom';
import { dataAlumno } from 'data/apiConection.js/dataAlumnos';
import { dataNotas, deleteNota } from 'data/apiConection.js/dataNotas';
import FormNota from 'components/app/alumnos/FormNotas';

const ContactDetails = () => {
  const [flagAddNota , setFlagAddNota ] = useState(false);
  const [alumno, setAlumno] = useState();
  const [notas, setNotas] = useState();
  const [show, setShow] = useState(false);
  const { id } = useParams(); 
  const handleClose = () => setShow(!show);
  const handleShow = () => setShow(!show);

  useEffect(() => {
    const fetchAlumno = async () => {
      try {
        const al = await dataAlumno(id,'2025');
        setAlumno(al);
      } catch (error) {
        console.error("Error fetching alumno data:", error);
      }
    };
    fetchAlumno();
  }, [id]);
  useEffect(() => {
    const fetchNotas = async () => {
      try {
        const nota = await dataNotas(id);
        setNotas(nota);
      } catch (error) {
        console.error("Error fetching notas data:", error);
      }
    };
    fetchNotas();
  }, [id,flagAddNota]);
  const onDelete = async (notas_id) => {
    try {
      const response = await deleteNota(notas_id);
      setFlagAddNota(!flagAddNota);
      return response;
    } catch (error) {
      console.error("Error deleting nota by id!")
    }
  }
  
  return (
    <>
      <ContactDetailsHeader handleShow={handleShow} />
      <Row className="g-3">
        <Col xxl={3} xl={4} className="order-xl-1">
          <div className="position-xl-sticky top-0">
            {alumno ? (
              <ContactProfile dataAlumno={alumno} />
            ) : (
              <p>Cargando Datos de Alumno</p>
            )}

            <Offcanvas
              show={show}
              onHide={handleClose}
              placement="end"
              className="dark__bg-card-dark"
            >
              <Offcanvas.Body className="scrollbar scrollbar-none-xl p-0">
                <IconButton
                  variant="falcon-default"
                  size="sm"
                  icon="plus"
                  transform="shrink-3"
                  className="ms-x1 my-x1"
                >
                  <span>Add</span>
                </IconButton>
              </Offcanvas.Body>
            </Offcanvas>
          </div>
        </Col>
        <Col>
          <Card>
            <FormNota alumno_id={id} alumno = {alumno} setFlagAddNota={setFlagAddNota} flagAddNota={flagAddNota} />
            <Tab.Container defaultActiveKey="notas">
              <SimpleBar>
                <Card.Header className="p-0 border-bottom">
                  <Nav className="nav-tabs border-0 flex-nowrap tab-contact-details">
                    <Nav.Item>
                      <Nav.Link
                        eventKey="notes"
                        className="d-flex align-items-center py-3 px-x1 mb-0"
                      >
                        <FontAwesomeIcon icon="file-alt" className="text-600" />
                        <h6 className="text-600 mb-0 ms-1">Notas</h6>
                      </Nav.Link>
                    </Nav.Item>
                  </Nav>
                </Card.Header>
              </SimpleBar>
              <Card.Body className="bg-light">
                <Tab.Content>
                  <Tab.Pane eventKey="notes">
                    {notas? <Notes alumno = {alumno} onDelete={onDelete} notasAlumno={notas} /> : <p>Cargando Notas</p>}
                  </Tab.Pane>
                </Tab.Content>
              </Card.Body>
            </Tab.Container>
          </Card>
        </Col>
      </Row>
    </>
  );
};

export default ContactDetails;
